import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import APPCONFIG from "constants/appConfig";

export const initialState = {
  serverTime: null,
  language: "DE",
  appState: "",
  holidays: [],
  snackbar: { open: false, severity: "info", message: "default" },
};

export const appdataSlice = createSlice({
  name: "appdata",
  initialState,
  reducers: {
    appdata_setServerTime: (state, action) => {
      state.serverTime = action.payload;
    },
    appdata_setHolidays: (state, action) => {
      state.holidays = action.payload;
    },
    appdata_setAppLanguage: (state, action) => {
      console.log("set app language to ", action.payload);
      state.language = action.payload;
    },
    appdata_setAppState: (state, action) => {
      state.appState = action.payload;
    },
    appdata_setSnackbar: (state, action) => {
      state.snackbar.severity = action.payload.severity
        ? action.payload.severity
        : "info";
      state.snackbar.message = action.payload.message
        ? action.payload.message
        : "";
      state.snackbar.open = action.payload.open ? action.payload.open : false;
    }
  }
});

export const {
  appdata_setAppLanguage,
  appdata_setAppState,
  appdata_setHolidays,
  appdata_setSnackbar,
  appdata_setServerTime
} = appdataSlice.actions;
export const appdataSelector = state => state.appdata;
export default appdataSlice.reducer;

export function appdata_updateServerTime() {
  console.log("update server time");
  return async (dispatch) => {
    axios
      .get(
        APPCONFIG.host +
        "api/lunchorder/time",
        {
          withCredentials: true,
          timeout: APPCONFIG.axiosTimeout,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        }
      )
      .then(response => {
        console.log("servertime - got response", response);
        let date = JSON.parse(response.data).date;
        dispatch(appdata_setServerTime(date));
      })
      .catch(er => {
        console.error("servertime error", er);
      });
  }
}

export function appdata_getHolidays() {
  console.log("get holidays")
  return async (dispatch, getstate) => {

    var instance = axios.create();
    delete instance.defaults.headers.common['Authorization'];

    var currentDate = new Date();

    console.log("holidays currentyear", currentDate.getFullYear())

    let thisYear = currentDate.getFullYear();
    let thisDay = currentDate.getDate();
    let thisMonth = currentDate.getUTCMonth() + 1;
    let nextYear = parseInt(thisYear) + 1;

    console.log("holiday", thisDay, thisMonth);

    instance
      .get(
        "https://openholidaysapi.org/PublicHolidays?countryIsoCode=AT&languageIsoCode=DE&validFrom=" + thisYear + "-" + thisMonth + "-" + thisDay + "&validTo=" + nextYear + "-12-31",
        {
          headers: {
            "Accept": "application/json",
          }
        }
      )
      .then(response => {
        console.log(
          "appdata - holidays received", response
        );

        let test = [];

        /*
          let a = {}
          a["id"] = 'a'
          a["startDate"] = '2024-04-29'
          a["endDate"] = '2024-04-29'
          a["name"] = [{
            language: 'DE',
            text: 'test'
          }]
          test.push(a);


          
          let b = {}
          b["id"] = 'b'
          b["startDate"] = '2023-09-12'
          b["endDate"] = '2023-09-12'
          b["name"] = [{
            language: 'DE',
            text: 'test2'
          }]
          test.push(b);
          
          let c = {}
          c["id"] = 'c'
          c["startDate"] = '2023-09-18'
          c["endDate"] = '2023-09-18'
          c["name"] = [{
            language: 'DE',
            text: 'test3'
          }]
          test.push(c); 
        */
        response.data.forEach(element => {
          test.push(element);
        });


        dispatch(appdata_setHolidays(test))
      })
      .catch(er => {
        console.log(
          "appdata - error on getting holidays ", er
        );
      });
  };
}
